import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

interface LegalPageShellProps {
  title: string;
  children: React.ReactNode;
}

const LegalPageShell: React.FC<LegalPageShellProps> = ({ title, children }) => {
  return (
    <div className="auth-page-wrapper pt-5 pb-5">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles-legal">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>
        </div>
      </div>

      <div className="auth-page-content">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <div className="mb-4 text-center">
                <Link
                  to="/login"
                  className="text-white-50 text-decoration-none small d-inline-flex align-items-center"
                >
                  <i className="ri-arrow-left-line me-1"></i>
                  Back to sign in
                </Link>
              </div>
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '16px',
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                }}
              >
                <CardBody className="p-4 p-md-5">
                  <h1 className="h3 fw-bold text-dark mb-4">{title}</h1>
                  <div className="legal-document text-muted" style={{ fontSize: '0.9375rem', lineHeight: 1.7 }}>
                    {children}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default LegalPageShell;
